{
  "version": 1,
  "asset_id": "5a0693c4-acee-4e70-b90c-08c8cfa16a8f",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/5a0693c4-acee-4e70-b90c-08c8cfa16a8f/palworld-bp01-box.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/5a0693c4-acee-4e70-b90c-08c8cfa16a8f/palworld-bp01-box.webp",
  "original_filename": "palworld-bp01-box.webp",
  "size": 59974,
  "content_type": "image/webp",
  "created_at": "2026-09-01T00:35:58Z"
}
